{
  "schemaVersion": "1.0",
  "researchAsOf": "2026-07-15",
  "retrievedAt": "2026-07-15",
  "scope": "Public voivodeship-level register routes for institutional foster-care facilities; no child-level or private-family data.",
  "sources": [
    {
      "voivodeship": "dolnośląskie",
      "authority": "Dolnośląski Urząd Wojewódzki",
      "sourceUrl": "https://bip.duw.pl/bip/rejestry-ewidencje-arc/wydzial-zdrowia-i-wydzia-polit/52,dok.html",
      "attachmentUrl": "https://bip.duw.pl/download/2/41470/REJESTRPOW31122024.xls",
      "fileType": "xls",
      "sourceAsOf": "2024-12-31",
      "retrievalDate": "2026-07-15",
      "freshnessStatus": "stale",
      "parseStatus": "binary_unavailable",
      "recordsExtracted": 0,
      "contentHash": null,
      "notes": "Archived BIP page; the current gov.pl route was found, but no newer public master-register attachment was resolved."
    },
    {
      "voivodeship": "kujawsko-pomorskie",
      "authority": "Kujawsko-Pomorski Urząd Wojewódzki",
      "sourceUrl": "https://bip.bydgoszcz.uw.gov.pl/66/rejestr-placowek-opiekunczo-wychowawczych-oraz-wolnych-miejsc-w-tych-placowkach.html",
      "attachmentUrl": "https://bip.bydgoszcz.uw.gov.pl/download/attachment/99/rejestr-placowek.docx?v=1622207196",
      "fileType": "docx",
      "sourceAsOf": null,
      "retrievalDate": "2026-07-15",
      "freshnessStatus": "unknown",
      "parseStatus": "binary_unavailable",
      "recordsExtracted": 0,
      "contentHash": null,
      "notes": "Official attachment is undated and appears old; currentness could not be established."
    },
    {
      "voivodeship": "lubelskie",
      "authority": "Lubelski Urząd Wojewódzki",
      "sourceUrl": "https://www.gov.pl/web/uw-lubelski/wykazy-i-rejestry-z-zakresu-polityki-spolecznej",
      "attachmentUrl": "https://luwwlublinie.bip.gov.pl/wydzial-polityki-spolecznej-rejestry/rejestr-placowek-opiekunczo-wychowawczych.html",
      "fileType": "html",
      "sourceAsOf": null,
      "retrievalDate": "2026-07-15",
      "freshnessStatus": "unresolved",
      "parseStatus": "landing_only",
      "recordsExtracted": 0,
      "contentHash": null,
      "notes": "Official child page timed out and no current attachment locator was recoverable."
    },
    {
      "voivodeship": "lubuskie",
      "authority": "Lubuski Urząd Wojewódzki",
      "sourceUrl": "https://bip.lubuskie.uw.gov.pl/polityka_spoleczna/pliki_polityka_spoleczna",
      "attachmentUrl": "https://bip.lubuskie.uw.gov.pl/download/Wykaz-placowek-opiekunczo-wychowawczych-wojewodztwa-lubuskiego-stan-na-30-pazdziernika-2025-r%2C29063.pdf",
      "fileType": "pdf",
      "sourceAsOf": "2025-10-30",
      "retrievalDate": "2026-07-15",
      "freshnessStatus": "aging",
      "parseStatus": "binary_unavailable",
      "recordsExtracted": 0,
      "contentHash": null,
      "notes": "Newest located official attachment; binary body was not retrievable in the research environment."
    },
    {
      "voivodeship": "łódzkie",
      "authority": "Łódzki Urząd Wojewódzki",
      "sourceUrl": "https://www.gov.pl/web/uw-lodzki/wykaz-placowek-opiekunczo-wychowawczych-regionalnych-placowek-opiekunczo-terapeutycznych-oraz-interwencyjnych-osrodkow-preadopcyjnych-dzialajacych-na-terenie-wojewodztwa-lodzkiego",
      "attachmentUrl": "https://www.gov.pl/attachment/1f4f14aa-b5df-423b-b3f2-7544eb491804",
      "fileType": "pdf+html",
      "sourceAsOf": "2026-07-01",
      "retrievalDate": "2026-07-15",
      "freshnessStatus": "current",
      "parseStatus": "parsed_html",
      "recordsExtracted": 87,
      "contentHash": null,
      "notes": "Current official HTML table was fully normalized; PDF attachment was separately located."
    },
    {
      "voivodeship": "małopolskie",
      "authority": "Małopolski Urząd Wojewódzki",
      "sourceUrl": "https://www.malopolska.uw.gov.pl/default.aspx?page=sprawdz_placowke_w_rejestrze_wojewody",
      "attachmentUrl": "https://www.malopolska.uw.gov.pl/doc/Typu_Socjalizacyjnego.doc",
      "fileType": "doc",
      "sourceAsOf": null,
      "retrievalDate": "2026-07-15",
      "freshnessStatus": "unknown",
      "parseStatus": "binary_unavailable",
      "recordsExtracted": 0,
      "contentHash": null,
      "notes": "Landing page exposes four type-specific DOC files, but dates/currentness and binary contents were unavailable. Additional files: Typu_Interwencyjnego.doc, Typu_Rodzinnego.doc, Typu_Specjalistyczno_Terapeutycznego.doc."
    },
    {
      "voivodeship": "mazowieckie",
      "authority": "Mazowiecki Urząd Wojewódzki",
      "sourceUrl": "https://www.gov.pl/web/uw-mazowiecki/rejestr2",
      "attachmentUrl": "https://www.gov.pl/attachment/a540c256-f5d2-4258-92dc-8eebe75b2829",
      "fileType": "xls",
      "sourceAsOf": null,
      "retrievalDate": "2026-07-15",
      "freshnessStatus": "unknown",
      "parseStatus": "binary_unavailable",
      "recordsExtracted": 0,
      "contentHash": null,
      "notes": "Official current landing and attachment locator found; no source-as-of date was exposed and the workbook body was unavailable."
    },
    {
      "voivodeship": "opolskie",
      "authority": "Opolski Urząd Wojewódzki",
      "sourceUrl": "https://www.gov.pl/web/uw-opolski/rejestr-placowek-opiekunczo-wychowawczych",
      "attachmentUrl": "https://www.gov.pl/web/uw-opolski/rejestr-placowek-opiekunczo-wychowawczych",
      "fileType": "xlsx",
      "sourceAsOf": "2025-11-30",
      "retrievalDate": "2026-07-15",
      "freshnessStatus": "content_mismatch",
      "parseStatus": "not_parsed",
      "recordsExtracted": 0,
      "contentHash": null,
      "notes": "Page updated 2025-12-23, but the visible attachment is a November vacancy report rather than a stable master register."
    },
    {
      "voivodeship": "podkarpackie",
      "authority": "Podkarpacki Urząd Wojewódzki",
      "sourceUrl": "https://nowa.rzeszow.uw.gov.pl/dla-instytucji/pomoc-spoleczna/wykaz-jednostek-udzielajacych-wsparcia-potrzebujacym/wykaz-placowek-opiekunczo-wychowawczych-regionalnych-placowek-opiekunczo-terapeutycznych-i-interwencyjnych-osrodkow-preadopcyjnych-wojewodztwa-podkarpackiego",
      "attachmentUrl": "https://nowa.rzeszow.uw.gov.pl/wp-content/uploads/2025/07/Wykaz-POW.doc",
      "fileType": "doc",
      "sourceAsOf": null,
      "retrievalDate": "2026-07-15",
      "freshnessStatus": "aging",
      "parseStatus": "binary_unavailable",
      "recordsExtracted": 0,
      "contentHash": null,
      "notes": "Official July 2025 upload found; exact register date and document body were unavailable."
    },
    {
      "voivodeship": "podlaskie",
      "authority": "Podlaski Urząd Wojewódzki",
      "sourceUrl": "https://www.gov.pl/web/uw-podlaski/placowki-opiekunczo-wychowawcze",
      "attachmentUrl": "https://www.gov.pl/attachment/197aa432-2ce2-4651-b3ae-1eb75a74004c",
      "fileType": "doc",
      "sourceAsOf": "2025-10-15",
      "retrievalDate": "2026-07-15",
      "freshnessStatus": "aging",
      "parseStatus": "binary_unavailable",
      "recordsExtracted": 0,
      "contentHash": null,
      "notes": "Official attachment name identifies the register date; document body was unavailable."
    },
    {
      "voivodeship": "pomorskie",
      "authority": "Pomorski Urząd Wojewódzki",
      "sourceUrl": "https://www.gov.pl/web/uw-pomorski/rejestr-placowek-opiekunczo-wychowawczych-regionalnych-placowek-opiekunczo-terapeutycznych-i-interwencyjnych-osrodkow-preadopcyjnych",
      "attachmentUrl": "https://www.gov.pl/attachment/d0b3dddb-708e-4ba5-91b5-591d666614ff",
      "fileType": "pdf",
      "sourceAsOf": "2025-01-14",
      "retrievalDate": "2026-07-15",
      "freshnessStatus": "stale",
      "parseStatus": "count_only",
      "recordsExtracted": 0,
      "contentHash": null,
      "notes": "Official PDF rendered, and register positions 1–83 were observed. Column order was scrambled in text extraction, so no facility rows were normalized safely."
    },
    {
      "voivodeship": "śląskie",
      "authority": "Śląski Urząd Wojewódzki",
      "sourceUrl": "https://www.katowice.uw.gov.pl/wdzps/placowki.html",
      "attachmentUrl": null,
      "fileType": "html",
      "sourceAsOf": null,
      "retrievalDate": "2026-07-15",
      "freshnessStatus": "unresolved",
      "parseStatus": "landing_unreachable",
      "recordsExtracted": 0,
      "contentHash": null,
      "notes": "Legacy official locator was unreachable and no current official replacement was established."
    },
    {
      "voivodeship": "świętokrzyskie",
      "authority": "Świętokrzyski Urząd Wojewódzki",
      "sourceUrl": "https://bip.kielce.uw.gov.pl/bip/rejestry-i-ewidencje/5808,Wydzial-Polityki-Spolecznej-i-Zdrowia.html",
      "attachmentUrl": "https://bip.kielce.uw.gov.pl/ftp/pliki/wps/WYKAZ_POW_na_strone_SUW-_stan_na_21_05_2025_r.pdf",
      "fileType": "pdf",
      "sourceAsOf": "2025-05-21",
      "retrievalDate": "2026-07-15",
      "freshnessStatus": "stale",
      "parseStatus": "parsed_pdf",
      "recordsExtracted": 46,
      "contentHash": null,
      "notes": "All 46 rendered register rows were normalized. Staleness and two visible source anomalies are retained in each affected record."
    },
    {
      "voivodeship": "warmińsko-mazurskie",
      "authority": "Warmińsko-Mazurski Urząd Wojewódzki",
      "sourceUrl": "https://www.gov.pl/web/uw-warminsko-mazurski/wsparcie-rodziny-i-piecza-zastepcza",
      "attachmentUrl": "https://www.gov.pl/attachment/a9330a91-377e-478e-b9fb-36e1b8846d01",
      "fileType": "xlsx",
      "sourceAsOf": "2024-10-04",
      "retrievalDate": "2026-07-15",
      "freshnessStatus": "stale",
      "parseStatus": "binary_unavailable",
      "recordsExtracted": 0,
      "contentHash": null,
      "notes": "Page was updated in 2025 but still exposes a workbook named for 4 October 2024."
    },
    {
      "voivodeship": "wielkopolskie",
      "authority": "Wielkopolski Urząd Wojewódzki",
      "sourceUrl": "https://www.poznan.uw.gov.pl/system/files/zalaczniki/rejestr_placowek_opiekunczo-wychowawczych_regionalnych_placowek_opiekunczo-terapeutycznych_i_interwencyjnych_osrodkow_preadopcyjnych_-_12.11.2024_aktualizacja.pdf",
      "attachmentUrl": "https://www.poznan.uw.gov.pl/system/files/zalaczniki/rejestr_placowek_opiekunczo-wychowawczych_regionalnych_placowek_opiekunczo-terapeutycznych_i_interwencyjnych_osrodkow_preadopcyjnych_-_12.11.2024_aktualizacja.pdf",
      "fileType": "pdf",
      "sourceAsOf": "2024-11-12",
      "retrievalDate": "2026-07-15",
      "freshnessStatus": "stale",
      "parseStatus": "binary_unavailable",
      "recordsExtracted": 0,
      "contentHash": null,
      "notes": "Official direct PDF found; no newer parent-page attachment was resolved."
    },
    {
      "voivodeship": "zachodniopomorskie",
      "authority": "Zachodniopomorski Urząd Wojewódzki",
      "sourceUrl": "https://szczecin.uw.gov.pl/contrast.php?action=view&id=162&type=article",
      "attachmentUrl": null,
      "fileType": "html",
      "sourceAsOf": "2023-04-03",
      "retrievalDate": "2026-07-15",
      "freshnessStatus": "stale",
      "parseStatus": "landing_unreachable",
      "recordsExtracted": 0,
      "contentHash": null,
      "notes": "Legacy official route timed out; the current attachment remains unresolved."
    }
  ]
}
